import React from "react";
import Ionicon from "react-ionicons";
import ajuda from "../../styles/images/menu-lateral/ajuda.png";
import alertas from "../../styles/images/menu-lateral/alertas.png";
import cartao from "../../styles/images/menu-lateral/cartao.png";
import configuracoes from "../../styles/images/menu-lateral/configuracoes.png";
import home from "../../styles/images/menu-lateral/home.png";
import integracao from "../../styles/images/menu-lateral/integracao.png";
import mobile from "../../styles/images/menu-lateral/mobile.png";
import radar from "../../styles/images/menu-lateral/radar.png";
import relatorios from "../../styles/images/menu-lateral/relatorios.png";
import convertIcon from "../../utils/iconUtils";

const TAMANHO_ICONE = 28;

const imagensPorIcone: { [icone: string]: string } = {
  "fa-home": home,
  "fa-bar-chart": radar,
  "fa-bar-chart-o": radar,
  "fa-credit-card-alt": cartao,
  "fa-file-text": relatorios,
  "fa-cogs": integracao,
  "fa-cog": configuracoes,
  "fa-question-circle": ajuda,
  "fa-mobile": mobile,
  "fa-bell": alertas,
};

const IconeMenu = ({ icon }: { icon: string }) => {
  const imagem = imagensPorIcone[icon.trim().split(" ")[1]];
  if (imagem) {
    return <img src={imagem} alt="" width={TAMANHO_ICONE} height={TAMANHO_ICONE} />;
  }
  return <Ionicon icon={convertIcon(icon)} color="#ffffff" fontSize={`${TAMANHO_ICONE}px`} />;
};

export default IconeMenu;
